import { createContext } from 'react';
import { AuthResponse } from '../dtos/auth';

interface UserContextType {
  user: AuthResponse | null;
  setUser: (user: AuthResponse | null) => void; // ✅ Correct function signature
}

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
});

export { UserContext };
